/* @flow */

import * as React from 'react';

export const RouteContext: React.Context<{
    isEmbedded: boolean,
}> = React.createContext({isEmbedded: true});
